// Note that the cart only handles products and prices etc related to products specifically.
// Shipping is handled by the checkout page.
//
// @todo This store currently switches around a bit between data validation being before or after the commit (before seeming more correct). Normalize.

// Currencies.
const currencies = {
  // Swedish Crown.
  SEK: {
    currency: 'SEK',
    token: ' kr',
    position: 'after',
    countryFlag: 'se'
  },

  // Danish Crown.
  DKK: {
    currency: 'DKK',
    token: ' kr.',
    position: 'after',
    countryFlag: 'dk'
  },

  // Euro
  EUR: {
    currency: 'EUR',
    token: '€',
    position: 'before',
    countryFlag: 'eu'
  },

  // US dollars
  USD: {
    currency: 'USD',
    token: '$',
    position: 'before',
    countryFlag: 'us'
  },

  // Australian dollars
  AUD: {
    currency: 'AUD',
    token: '$',
    position: 'before',
    countryFlag: 'au'
  }
}

// Use to set default currency when changing top domain.
/* eslint-disable */
const currencyByTopDomain = {
  ['.se']: 'SEK',
  ['.dk']: 'DKK',
  ['.en']: 'EUR',
  ['.fr']: 'EUR',
  ['.fi']: 'EUR',
  ['.nl']: 'EUR',
  ['.de']: 'EUR',
  ['.pl']: 'EUR',
  ['.ru']: 'USD',
  ['.com']: 'EUR',
  localhost: 'SEK'
}
/* eslint-enable */

const cartItem = {
  type: '', // poster, giftCard
  product: {
    key: '',
    name: '',
    id: ''
  },
  options: {
    // ChildName is the name of the child, printed on the poster.
    childName: '',
    // Length is the child's birth length.
    length: 0,
    // Weight is the child's birth weight.
    weight: 0,
    // BirthDate is a formatted string for the birth date.
    birthDate: '',
    // BirthTime is the time the child was born, formatted in the way it's formatted on the poster.
    birthTime: '',
    // Color is the poster's color variant.
    color: '',
    // Presentation is either "full-size" or "white-frame"
    presentation: '',

    // Gift cards specific options
    deliveryMethod: ''
  },
  // Count is the number of copies of this product that will be provided.
  count: 0,
  // Price is the price of the product to be displayed in the cart.
  price: {
    amount: 0,
    currency: 'SEK'
  },
  // svgB64 is the base64 encoded HTML of the poster. It's used to show the thumbnail and to submit the actual data to
  // the back end when committing the purchase.
  svgB64: ''
}

export default {
  strict: true,
  state: {
    // items holds an array of "cartItems".
    items: [],
    currency: JSON.parse(JSON.stringify(currencies.SEK)),
    currencyIsSet: false
  },

  mutations: {
    ADD_ITEM (state, item) {
      state.items.push(item)
    },
    REMOVE_ITEM (state, index) {
      state.items.splice(index, 1)
    },
    INCREMENT_ITEM (state, index) {
      if (state.items.length < index - 1) {
        return
      }
      state.items[index].count += 1
    },
    DECREMENT_ITEM (state, index) {
      if (state.items.length < index - 1) {
        return
      }
      state.items[index].count = Math.max(1, state.items[index].count - 1)
    },
    EMPTY_CART (state) {
      state.items = []
    },
    SET_CURRENCY (state, key) {
      if (typeof currencies[key] !== 'undefined') {
        state.currency = JSON.parse(JSON.stringify(currencies[key]))
      }
    },
    SET_CURRENCY_IS_SET (state, value) {
      state.currencyIsSet = value
    },

    // data should be in the following format:
    //
    // {
    //  template: [poster name],
    //  price: {
    //    currency: [currency ISO code],
    //    amount: [price in this currency]
    //  }
    // }
    UPDATE_CART_ITEM_CURRENCY (state, data) {
      state.items.forEach(function (item) {
        if (item.product.key === data.product.key) {
          item.price.currency = data.price.currency
          item.price.amount = data.price.amount
        }
      })
    },

    SET_CART_ITEM_ID (state, data) {
      state.items[data.index].id = data.id
    }
  },

  actions: {
    // Note that Vue interprets the cleanCartItem as a computed property, which means that when adding an item to the
    // cart, we still need to apply the JSON deep copy, or we'll get the first item in the cart over and over!
    addItem ({ commit, state, dispatch }, newItem) {
      let index
      state.items.forEach((item, idx) => {
        const productOne = JSON.stringify(item.product)
        const productTwo = JSON.stringify(newItem.product)
        if (productOne === productTwo) {
          const optionsOne = JSON.stringify(item.options)
          const optionsTwo = JSON.stringify(newItem.options)
          if (optionsOne === optionsTwo) {
            index = idx
          }
        }
      })

      if (index) {
        dispatch('incrementItem', index)
      } else {
        dispatch('trackAddToCart', newItem)
        commit('ADD_ITEM', newItem)
      }
    },

    removeItem ({ commit, state, dispatch }, index) {
      // Track
      let item = state.items[index]
      if (item) {
        dispatch('trackRemoveFromCart', { product: item, quantity: item.count })
      }

      commit('REMOVE_ITEM', index)
    },

    incrementItem ({ commit, state, dispatch }, index) {
      // Track
      let item = state.items[index]
      if (item) {
        dispatch('trackAddToCart', item)
      }

      commit('INCREMENT_ITEM', index)
    },

    decrementItem ({ commit, state, dispatch }, index) {
      let item = state.items[index]
      if (!item || item.count < 2) {
        return
      }

      // Track
      if (item) {
        dispatch('trackRemoveFromCart', { product: item, quantity: 1 })
      }

      commit('DECREMENT_ITEM', index)
    },

    emptyCart ({ commit, state, dispatch }) {
      /* state.items.forEach(function (item) {
        dispatch('trackRemoveFromCart', { product: item, quantity: item.count })
      }) */

      commit('EMPTY_CART')
    },

    setCurrency ({ commit, getters }, selector) {
      // Set the currency in the store.
      commit('SET_CURRENCY', selector)
      // Update all cart items.
      let metadata = { ...getters.postersMetaData, ...getters.giftCardsMetadata, ...getters.productsMetadata }
      getters.cartItems.forEach(function (item) {
        if (item.price.currency !== selector) {
          if (metadata[item.product.key]) {
            let payload = {
              product: {
                key: item.product.key
              },
              price: {
                amount: metadata[item.product.key].prices[selector],
                currency: selector
              }
            }
            commit('UPDATE_CART_ITEM_CURRENCY', payload)
          }
        }
      })
    },

    setCurrencyIsSet ({ commit, getters }, value) {
      commit('SET_CURRENCY_IS_SET', value)
    }
  },

  getters: {
    // cleanCartItems returns an empty cart item on which values can be set. It's used since dispatching in the store
    // only accepts one parameter, meaning that we have to send the entire object.
    //
    // Note that Vue interprets this as a computed property, which means that when adding an item to the cart, we still
    // need to apply the JSON deep copy!
    cleanCartItem (state) {
      return cartItem
    },

    cartItems (state) {
      return state.items
    },

    currencies (state) {
      let ret = []
      Object.entries(currencies).forEach(function (currency) {
        ret.push(currency[1])
      })
      return ret
    },

    currency (state) {
      return state.currency
    },

    currencyIsSet (state) {
      return state.currencyIsSet
    },

    currencyByTopDomain () {
      return currencyByTopDomain
    },

    cartSubTotal (state) {
      let ret = 0
      state.items.forEach(function (item) {
        ret += item.price.amount * item.count
      })
      return ret
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/cart.js